"use strict";

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DidProvider = void 0;

var did_jwt_1 = require("did-jwt");

var rpc_utils_1 = require("rpc-utils");

var utils_1 = require("./utils");

var methods = {
  did_authenticate: function did_authenticate(_ref) {
    var wallet = _ref.wallet,
        origin = _ref.origin;
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return wallet.authenticate([], {}, origin);

            case 2:
              return _context.abrupt("return", {
                did: wallet.DID
              });

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  },
  did_createJWS: function did_createJWS(_ref2, params) {
    var wallet = _ref2.wallet,
        origin = _ref2.origin;
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var signer, header, jws;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return wallet.isAuthenticated([], origin);

            case 2:
              if (_context2.sent) {
                _context2.next = 4;
                break;
              }

              throw new rpc_utils_1.RPCError(0, 'Authentication required');

            case 4:
              signer = wallet.getRootSigner(params.pubKeyId);
              header = params.protected ? utils_1.toStableObject(params.protected) : undefined;
              _context2.next = 8;
              return did_jwt_1.createJWS(utils_1.toStableObject(params.payload), signer, header);

            case 8:
              jws = _context2.sent;
              return _context2.abrupt("return", {
                jws: jws
              });

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
  }
};

var DidProvider = /*#__PURE__*/function () {
  function DidProvider(wallet) {
    _classCallCheck(this, DidProvider);

    this._handle = rpc_utils_1.createHandler(methods);
    this._wallet = wallet;
  }

  _createClass(DidProvider, [{
    key: "isDidProvider",
    get: function get() {
      return true;
    }
  }, {
    key: "send",
    value: function send(msg, origin) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this._handle({
                  origin: origin,
                  wallet: this._wallet
                }, msg);

              case 2:
                return _context3.abrupt("return", _context3.sent);

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }]);

  return DidProvider;
}();

exports.DidProvider = DidProvider;